import { quotationConfigAxios } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';
import { makeNotificationNewQuotationData, makeNotificationRequestQuotationData } from '@/utils';

export const createSolicitation = async data => {
    const api = quotationConfigAxios();
    await api.post(ENDPOINTS.QUOTATIONS_REQUESTS, data);
};

export const getQuotationsRequest = async (id = false) => {
    const api = quotationConfigAxios();
    let url = ENDPOINTS.ADMINISTRATOR_QUOTATIONS_REQUESTS;
    if (id) url += `${id}`;
    const { data } = await api.get(url);
    return data;
};

export const removeQuotationRequestConfirm = async requestId => {
    const api = quotationConfigAxios();
    await api.delete(ENDPOINTS.QUOTATIONS_REQUESTS, requestId);
};

export const getCostCenters = async () => {
    const api = quotationConfigAxios();
    const { data } = await api.get(ENDPOINTS.COST_CENTERS);
    return data;
};

export const createCostCenter = async payload => {
    const api = quotationConfigAxios();
    const { data } = await api.post(ENDPOINTS.COST_CENTERS, payload);
    return data;
};

export const callNotificationNewQuotation = async payload => {
    const api = quotationConfigAxios();
    await api.post(ENDPOINTS.NOTIFICATION_NEW_QUOTATION, payload);
};

export const sendNotification = async form => {
    const payload = makeNotificationNewQuotationData(form);
    callNotificationNewQuotation(payload);
};

export const sendNotificationRequestQuotation = async form => {
    const payload = makeNotificationRequestQuotationData(form);
    callNotificationNewQuotation(payload);
};

export const getSupplierCategories = async () => {
    const api = quotationConfigAxios();
    const { data } = await api.get(`${ENDPOINTS.SUPPLIER_LIST_QUOTATIONS_CATEGORIES}?type=category`);
    return data;
};
export const getServicesContractors = async () => {
    const api = quotationConfigAxios();
    const { data } = await api.get(`${ENDPOINTS.SUPPLIER_LIST_QUOTATIONS_CATEGORIES}?type=contractor`);
    return data;
};
export const getQuotationStructuredQuestion = async id => {
    const api = quotationConfigAxios();
    const { data } = await api.get(`${ENDPOINTS.QUOTATION_STRUCTURED_QUESTION}${id}/`);
    return data;
};
export const adwordNotification = async payload => {
    const api = quotationConfigAxios();
    await api.post(ENDPOINTS.ADWORDS_ALERT, payload);
};
